var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.803 4.084l-9.899 9.9c-.26.26-.682.26-.943 0l-.943-.944L.195 9.217c-.26-.26-.26-.682 0-.942l.943-.943c.26-.26.683-.26.943 0l3.352 3.352 8.485-8.486c.26-.26.682-.26.943 0l.942.943c.26.26.26.682 0 .943z"
  })));
};

export default SvgCheck;